import Link from 'next/link';
import { useRouter } from 'next/router';
import { useContext } from 'react';
import { NextImage } from 'src/components/shared/elements/NextImage';
import { OnlyInPc } from 'src/components/shared/layouts/Responsive';
import { KaimonoWebRoutes } from 'src/config/routes';
import { I18nContext } from 'src/stores/I18n';
import styles from './index.module.scss';

export const CouponBannerForPc = () => {
  const { locale } = useRouter();
  const localeResources = useContext(I18nContext);
  return (
    <OnlyInPc className={styles.bannerPcContainer}>
      <Link href={KaimonoWebRoutes.couponList}>
        <a className={styles.image}>
          <NextImage
            src={`/kaimono/images/allVisitorCampaign/pc/${locale === 'ja' ? 'en' : locale}.webp`}
            width={100}
            height={160}
            alt={localeResources.allVisitorCampaign.getSoon}
          />
        </a>
      </Link>
    </OnlyInPc>
  );
};
